import ScrollMagic from 'scrollmagic';
import { popUpTimeline, popUpCloseTimeline } from '../gsap/index.js';
require('scrollmagic/scrollmagic/uncompressed/plugins/animation.gsap');


export function clickScrollAction (controller) {
	controller.scrollTo((newpos) => {
		TweenMax.to(window, 1, { scrollTo: { y: newpos }, ease: Power1.easeInOut });
	}); // change behaviour of controller to animate scroll instead of jump

	// for Jump links
	// $(document).on('click', 'a:not(.noScroll)[href^="#"]', (e) => {
	$(document).on('click', 'a.smoothScroll[href^="#"]', (e) => {
		e.preventDefault();
		let id = $(e.currentTarget).attr('href'); // scroll to the start of the nth ID
		controller.scrollTo(id); // trigger scroll
	});
};


export function popUpScene (controller) {
	if (!($('body').hasClass('popped'))) {	
		let popUpScene = new ScrollMagic.Scene({
			triggerElement: '#main'
		})
		.setTween(popUpTimeline)
		.addTo(controller)
		.setClassToggle("body", "popped");
		return popUpScene;
	}
};

export function popUpCloseScene (controller) {
	$(document).ready(function() {
		let closer = popUpCloseTimeline();
		$(document).on('click', '.close', function(e) {
			e.preventDefault();
			closer.play();
		});
	});
};
